<div class="container">
    <h1>Report Failed to Load</h1>
    <div>You may not be authorized to access this Similarity Report. If you feel this is an error, contact student support services.</div>
</div>
